export default __webpack_public_path__ + "static/media/miroslav.1d19eb12.jpg";